const INDEX_ITEMS = [
  { id: 1, title: '2024暑期档观影指南', count: '32部', desc: '精选暑期院线大片与经典重温' },
  { id: 2, title: '国产喜剧电影合集', count: '48部', desc: '开心麻花、徐峥、黄渤经典作品' },
  { id: 3, title: '高分悬疑剧推荐', count: '25部', desc: '豆瓣8分以上悬疑推理佳作' },
  { id: 4, title: '韩剧经典必看榜', count: '36部', desc: '从经典到最新热播全收录' },
  { id: 5, title: '动漫剧场版精选', count: '52部', desc: '日漫国漫高分剧场版一网打尽' },
  { id: 6, title: '奥斯卡获奖影片', count: '28部', desc: '历年奥斯卡最佳影片合集' },
  { id: 7, title: '科幻大片全收藏', count: '40部', desc: '硬核科幻与视觉奇观精选' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100 scroll-mt-20">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              专题合集
            </h2>
            <p className="text-sm text-foreground-600">按类型和主题精心整理的观影专题</p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {INDEX_ITEMS.map((item) => (
              <div
                key={item.id}
                className="group bg-background-50 border border-background-200 rounded-xl p-5 hover:border-secondary-400 transition-all duration-300 cursor-pointer"
              >
                <div className="flex items-start justify-between mb-2">
                  <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors">
                    {item.title}
                  </h3>
                  <span className="flex-shrink-0 px-2 py-0.5 bg-secondary-100 text-secondary-700 text-xs font-medium rounded whitespace-nowrap">
                    {item.count}
                  </span>
                </div>
                <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
                <div className="flex items-center gap-1 mt-3 text-xs text-primary-500 font-medium opacity-0 group-hover:opacity-100 transition-opacity">
                  浏览专题 <span className="w-3 h-3 flex items-center justify-center"><i className="ri-arrow-right-s-line"></i></span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}